import gql from "graphql-tag";

export const RESCHEDULE = gql`
	mutation ($mailSetId: UUID!, $datetime: DateTime!) {
		reschedule(
			input: {
				mailSetId: $mailSetId,
				scheduledDateTime: $datetime
			}
		) {
			success
			errors
		}
	}
`;
